import React from 'react';
import DoorConfigurator from '../components/DoorConfigurator';
import MouldingConfigurator from '../components/MouldingConfigurator';
import WoodBeamConfigurator from '../components/WoodBeamConfigurator';
import FlooringConfigurator from '../components/FlooringConfigurator';

export default function getConfigurator(configurator) {
  switch(configurator) {
    case 'door':
      return React.createElement(DoorConfigurator);
    case 'moulding':
      return React.createElement(MouldingConfigurator);
    case 'wood-beam':
      return React.createElement(WoodBeamConfigurator);
    case 'flooring':
      return React.createElement(FlooringConfigurator);
  }
}